/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Extraction_In_ProgressInputs */

const en_statement_taxonomy_extraction_in_progress = /** @type {(inputs: Statement_Taxonomy_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wait for statement extraction to finish before publishing this tree. Your draft remains available.`)
};

const nl_statement_taxonomy_extraction_in_progress = /** @type {(inputs: Statement_Taxonomy_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wacht tot de jaarrekeningextractie is afgerond voordat je deze boom publiceert. Je concept blijft beschikbaar.`)
};

/**
* | output |
* | --- |
* | "Wait for statement extraction to finish before publishing this tree. Your draft remains available." |
*
* @param {Statement_Taxonomy_Extraction_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_extraction_in_progress = /** @type {((inputs?: Statement_Taxonomy_Extraction_In_ProgressInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Extraction_In_ProgressInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_extraction_in_progress(inputs)
	return en_statement_taxonomy_extraction_in_progress(inputs)
});